module.exports = __webpack_public_path__ + "img/zhaomu.b08b5b25.jpg";